import { FC } from 'react';
import { Spin } from 'antd';
import { ActivityTip, IActivityTipProps } from '@base/cart/CartActivityTips/ActivityTip';
import { CartType } from '@base/cart/useCart';

type CartActivityTipsProps = {
    className?: string;
    type: IActivityTipProps['type'];
    cart: CartType;
    bonusListType?: 'm' | 'pc';
};


const CartActivityTips: FC<CartActivityTipsProps> = props => {
    const {
        className = '',
        type,
        cart,
        bonusListType,
    } = props;

    return !cart.activityTips.length ? null : (
        <div className={className}>
            <Spin spinning={cart.summaryLoading}>
                {cart.activityTips.map((item, idx) => (
                    <ActivityTip
                        key={`${item}-${idx}`} {...item}
                        type={type}
                        cart={cart}
                        bonusListType={bonusListType}
                        {...item}
                    />
                ))}
            </Spin>
        </div>
    )
};

export default CartActivityTips;